module.exports = __webpack_public_path__ + "static/media/ic_swap.d1b251ba.svg";